import React from "react";
import { useMachine } from "@xstate/react";
import { fileRepairMachine } from "@/containers/FileRepair/state/machine";
import { DragAndDropSelection } from "@/components/DragAndDropSelection";
import { DroppedFile } from "@/containers/FileRepair/components/DroppedFile";
import { UploadingFile } from "@/containers/FileRepair/components/UploadingFile";
import { Error } from "@/containers/FileRepair/components/Error";
import { Preview } from "@/containers/FileRepair/components/Preview";
import { DownloadFile } from "@/containers/FileRepair/components/DownloadFile";

export const FileRepairContainer: React.FC = () => {
  const [current, send] = useMachine(fileRepairMachine);

  const { context: ctx } = current;

  const showDragAndDropSelection = current.matches("selectingFile");
  const showDroppedFile = current.matches("droppedFile");
  const showUploadingOriginalFile =
    current.matches("uploading") || current.matches("pollingUploadStatus");
  const showPreview = current.matches("preview");
  const showUploadingRepairedFile =
    current.matches("repair") ||
    current.matches("pollingRepairedFileUploadStatus") ||
    current.matches("fetchingDownloadUrl");
  const showRepairedFilePreview = current.matches("repairedFilePreview");
  const showError = current.matches("error");

  return (
    <>
      {showDragAndDropSelection && (
        <DragAndDropSelection
          acceptedFilesFormats={[".xd"]}
          handleFileDrop={files => {
            if (files && files.length > 0) {
              send({
                type: "SELECT_FILE",
                file: files[0],
              });
            }
          }}
        />
      )}

      {showDroppedFile && (
        <DroppedFile
          file={ctx.file!}
          onFileSubmit={() =>
            send({
              type: "SUBMIT_FILE_FORM",
              userEmail: ctx.userEmail!,
            })
          }
          onFileReset={() =>
            send({
              type: "RESET_FILE",
            })
          }
        />
      )}

      {showUploadingOriginalFile && <UploadingFile fileType="original" />}

      {showPreview && (
        <Preview
          file={ctx.file!}
          onRepairBtnClick={() =>
            send({
              type: "REPAIR_FILE",
            })
          }
        />
      )}

      {showUploadingRepairedFile && <UploadingFile fileType="repaired" />}

      {showRepairedFilePreview && (
        <DownloadFile
          fileName={ctx.uploadedFileName!}
          downloadUrl={ctx.repairedFileDownloadUrl!}
          onRepairAnotherFile={() =>
            send({
              type: "REPAIR_ANOTHER_FILE",
            })
          }
        />
      )}

      {showError && <Error />}
    </>
  );
};
